export default __webpack_public_path__ + "static/media/Evolve.34bc65e8.svg";